<template>
  <div>
    <div class="r-tabs-accordion-title r-tabs-state-active"><a href="#tab-1" class="r-tabs-anchor">Vlastnosti</a></div>
    <div class="tabs_content r-tabs-panel r-tabs-state-active" id="tab-1" style="display: block;">

      <section>
        <div class="left">
          <detail-entity-info
              :entity="entity"
              :title="$gettext('Základní údaje')"
          />
        </div>

        <div class="right">
          <div class="field_left">
            <text-input
                id="name"
                :required="true"
                :disabled="!isEditable"
                v-model="entity.name"
                ref="nameref"
            >
              <translate class="translate">Název</translate>
            </text-input>
          </div>
        </div>
      </section>

      <section>
        <div class="left">
          <h2 v-translate>Lineární vysílání</h2>
        </div>

        <div class="right">

          <div class="field_left">
              <text-input
                  id="time_with_no_advertisement_after_start_seconds"
                  :required="true"
                  :disabled="!isEditable"
                  v-model="entity.time_with_no_advertisement_after_start_seconds"
                  ref="time_with_no_advertisement_after_start_secondsref"
              >
                <translate class="translate">Čas bez možnosti přeskočení od spuštění streamu</translate> <span>(s)</span>
              </text-input>
          </div>

          <div class="field_right">
            <text-input
                id="skip_after_seconds"
                :required="true"
                :disabled="!isEditable"
                v-model="entity.skip_after_seconds"
                ref="skip_after_secondsref"
            >
              <translate class="translate">Minimální čas přehrání reklamního bloku</translate> <span>(s)</span>
            </text-input>
          </div>

          <div class="field_left">
            <text-input
                id="osd_delay_seconds"
                :required="true"
                :disabled="!isEditable"
                v-model="entity.osd_delay_seconds"
                ref="osd_delay_secondsref"
            >
              <translate class="translate">Čas pro automatické skrytí OSD</translate> <span>(s)</span>
            </text-input>

          </div>

          <div class="field_left">
            <checkbox-input
                :disabled="!isEditable"
                id="automatic_osd_showup"
                v-model="entity.automatic_osd_showup"
                ref="automatic_osd_showupref"
            >
              <translate class="translate">Automaticky zobrazit OSD v reklamním bloku</translate>
            </checkbox-input>
          </div>

          <div class="field_left">
            <checkbox-input
                :disabled="!isEditable"
                id="skippable"
                v-model="entity.skippable"
                ref="skippableref"
            >
              <translate class="translate">Povolit přeskakování reklamního bloku</translate>
            </checkbox-input>
          </div>

          <div class="field_right">
            <p class="field">
              <checkbox-input
                  :disabled="!isEditable"
                  id="allow_skip_multiple_advertisement_blocks"
                  v-model="entity.allow_skip_multiple_advertisement_blocks"
                  ref="allow_skip_multiple_advertisement_blocksref"
              >
                <translate class="translate">Povolit přeskakování více reklamních bloků</translate>
              </checkbox-input>
            </p>
          </div>
        </div>
      </section>

      <section>
        <div class="left">
          <h2>Nelineární vysílání</h2>
        </div>

        <div class="right">

          <div class="field_left">
            <text-input
                id="time_with_no_advertisement_after_start_seconds_nonlinear"
                :required="true"
                :disabled="!isEditable"
                v-model="entity.time_with_no_advertisement_after_start_seconds_nonlinear"
                ref="time_with_no_advertisement_after_start_seconds_nonlinearref"
            >
              <translate class="translate">Čas bez možnosti přeskočení od spuštění streamu</translate> <span>(s)</span>
            </text-input>
          </div>

          <div class="field_right">
            <text-input
                id="skip_after_seconds_nonlinear"
                :required="true"
                :disabled="!isEditable"
                v-model="entity.skip_after_seconds_nonlinear"
                ref="skip_after_seconds_nonlinearref"
            >
              <translate class="translate">Minimální čas přehrání reklamního bloku</translate> <span>(s)</span>
            </text-input>
          </div>

          <div class="field_left">
            <text-input
                id="osd_delay_seconds_nonlinear"
                :required="true"
                :disabled="!isEditable"
                v-model="entity.osd_delay_seconds_nonlinear"
                ref="osd_delay_seconds_nonlinearref"
            >
              <translate class="translate">Čas pro automatické skrytí OSD</translate> <span>(s)</span>
            </text-input>

          </div>

          <div class="field_left">
            <checkbox-input
                :disabled="!isEditable"
                id="automatic_osd_showup_nonlinear"
                v-model="entity.automatic_osd_showup_nonlinear"
                ref="automatic_osd_showup_nonlinearref"
            >
              <translate class="translate">Automaticky zobrazit OSD v reklamním bloku</translate>
            </checkbox-input>
          </div>

          <div class="field_left">
            <checkbox-input
                :disabled="!isEditable"
                id="skippable_nonlinear"
                v-model="entity.skippable_nonlinear"
                ref="skippable_nonlinearref"
            >
              <translate class="translate">Povolit přeskakování reklamního bloku</translate>
            </checkbox-input>
          </div>

          <div class="field_right">
            <checkbox-input
                :disabled="!isEditable"
                id="allow_skip_multiple_advertisement_blocks_nonlinear"
                v-model="entity.allow_skip_multiple_advertisement_blocks_nonlinear"
                ref="allow_skip_multiple_advertisement_blocks_nonlinearref"
            >
              <translate class="translate">Povolit přeskakování více reklamních bloků</translate>
            </checkbox-input>
          </div>
        </div>
      </section>

      <section class="buttons">
        <router-link :to="{ name: 'advertisingProviderChannelGroups', params: { id: entity.id_advertising_provider} }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
        <input
            v-if="$_updateActionAllowed"
            type="submit"
            :value="'Uložit' | translate"
            class="btn"
            @click.prevent.stop="$emit('updateEntity')">
      </section>
    </div>
  </div>
</template>

<script>
import DetailEntityInfo from "../../../common/DetailEntityInfo.vue";

export default {
  name: 'AdvertisingProviderChannelGroupDetailSettings',
  components: { DetailEntityInfo },
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      moduleName: 'advertisingProviders',
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingProviders/channelGroup/Settings.vue